import { render, staticRenderFns } from "./packing-slip.vue?vue&type=template&id=0662cf3e&"
import script from "./packing-slip.vue?vue&type=script&lang=js&"
export * from "./packing-slip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports